import { ActivityGroupStatus } from '../interfaces/ActivityGroupStatus.enum';
import { COLORS } from './colors.constants';
import { Languages } from './languages';

export const intercomBaseURL: string = 'https://intercom.help/trusstor-d19f78c950cd/en/articles/';

export const intercomBaseHebURL: string = 'https://intercom.help/trusstor-d19f78c950cd/he/articles/';

export const intercomLinks: { userPermissionsLinks: { [key: string]: string } } = {
	userPermissionsLinks: {
		[Languages.HEBREW]: `${intercomBaseHebURL}6876190`,
		[Languages.ENGLISH_US]: `${intercomBaseURL}6876190-user-s-permission`,
	},
};

export enum ActivityStatusTypes {
	AS_PLANNED = 'asPlanned',
	PARTIAL = 'partial',
	DEFICIENT = 'deficient',
	NOT_BEGAN = 'notBegan',
}

export enum SORT_ORDER {
	ASCENDING = 'asc',
	DESCENDING = 'desc',
}

export enum IconPatchStatuses {
	DEFAULT = 'default',
	HOVER = 'hover',
	SELECTED = 'selected',
}

export const equipmentTypes = {
	safety: 'Safety',
	optic: 'Optic',
	electricity: 'Electricity',
	powerTools: 'Power Tools',
	bondingMachinery: 'Bonding Machinery',
	waterDrainage: 'Water & Drainage',
	pavingTiling: 'Paving & Tiling',
	welding: 'Welding',
	movingLifting: 'Moving & lifting',
	height: 'Height',
	heavyEquipment: 'Heavy Equipment',
	scissorsLift: 'Scissors Lift',
};

export enum HEADERS {
	authorization = 'authorization',
	tz = 'tz',
	projectId = 'project-id',
	organizationId = 'organization-id',
	correlationId = 'correlation-id',
	username = 'username',
	workDayHours = 'workDayHours',
	webClientVersion = 'web-client-version',
	isDemo = 'is-demo',
	/**
	 * Which client application is calling — see `Product`. Auth reads it to pick the mail
	 * profile (brand, locale, link host) for anything it sends on the user's behalf.
	 */
	product = 'product',
	/**
	 * Which KIND of credential mail Auth should render for a `request-password-reset` — a
	 * reset, or a first-time invitation. Both flows mint the same engine token and land on the
	 * same set-password page; only the wording differs. Sent by Auth's own internal invite
	 * route, never by a browser.
	 */
	mailKind = 'mail-kind',
	/**
	 * Which one-time-code CHANNEL a second-factor challenge should be delivered on (`email`,
	 * `sms`). Sent on `two-factor/send-otp` when the user picks a channel other than their
	 * principal one.
	 *
	 * A header rather than a body field because Better Auth validates that endpoint's body with
	 * a fixed zod object and strips unknown keys — a body `channel` never reaches `sendOTP`.
	 */
	mfaChannel = 'x-mfa-channel',
}

// The refresh endpoint must never be re-entered into the 401 -> refresh flow (it would await its own promise)
export const REFRESH_TOKEN_API_PATH: string = '/auth/authentication/refresh';

export enum ActivityStatusTypesColor {
	asPlanned = '#79a41c',
	partial = '#f9bc14',
	deficient = '#d34e0a',
}

export const activitiesStatusesColors = {
	[ActivityGroupStatus.overdue]: COLORS.red600,
	[ActivityGroupStatus.delayed]: COLORS.red600,
	[ActivityGroupStatus.inProgress]: COLORS.yellow500,
	[ActivityGroupStatus.planned]: COLORS.primaryColor,
	[ActivityGroupStatus.complete]: COLORS.green600,
};
